<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="terminalNum" placeholder="终端主机号" style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker type="daterange" size="small" :start-date="new Date()" placement="bottom-end"
                  placeholder="定位时间范围" style="width: 200px;margin-right: 3px;"
                  v-model="dateFilter"></DatePicker>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
              @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  name: 'tripanalysiss',
  components: {},
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      stateFilter: null,
      offlineFilter: null,
      tripTypeFilter: null,

      dateFilter: [],
      startDate: null,
      endDate: null,

      // 离线处理
      processOfflineModal: false,
      processOfflineId: null,

      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      terminalNum: null,
      columns: [
        {
          title: '终端主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '行程类型',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '停车', value: 0 },
            { label: '行驶', value: 1 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.tripTypeFilter = []
              val.forEach(item => {
                this.tripTypeFilter.push(genQueryParam('tripType', 'EQ', item))
              })
            } else {
              this.tripTypeFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.tripType == 0) {
              return h('label', '停车')
            } else if (params.row.tripType == 1) {
              return h('label', '行驶')
            }
          }
        },
        {
          title: '行程开始时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'startDatetimeLongValue',
          width: 180,
          render: function (h, params) {
            if (params.row.startDatetimeLongValue) {
              let d = new Date(params.row.startDatetimeLongValue)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '行程结束时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'endDatetimeLongValue',
          width: 180,
          render: function (h, params) {
            if (params.row.endDatetimeLongValue) {
              let d = new Date(params.row.endDatetimeLongValue)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '行驶时长',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            let date3 = params.row.endDatetime - params.row.startDatetime
            let leave1 = date3
            let hours = Math.floor(leave1 / (3600 * 1000))
            // 计算相差分钟数
            let leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
            let minutes = Math.floor(leave2 / (60 * 1000))
            // 计算相差秒数
            let leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
            let seconds = Math.round(leave3 / 1000)
            let result = ''
            if (hours > 0) {
              result += hours + '小时'
            }
            if (minutes > 0) {
              result += minutes + '分'
            }
            if (seconds > 0) {
              result += seconds + '秒'
            }
            return h('label', result)
          }
        },
        {
          title: '行程起点',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'startAddress',
          width: 300,
          render: function (h, params) {
            let d = [
              h('div', params.row.startAddress),
              h('div', params.row.startAddressEx)
            ]
            return h('div', d)
          }
        },
        {
          title: '行程终点',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'endAddress',
          width: 300,
          render: function (h, params) {
            let d = [
              h('div', params.row.endAddress),
              h('div', params.row.endAddressEx)
            ]
            return h('div', d)
          }
        },
        {
          title: '行程总GPS里程',
          resizable: true,
          key: 'totalGpsMileage',
          ellipsis: 'true',
          width: 110,
          render: function (h, params) {
            if (params.row.totalGpsMileage !== 0) {
              return h('div', params.row.totalGpsMileage / 10)
            } else {
              return h('div', params.row.totalGpsMileage)
            }
          }
        },
        {
          title: '行程总里程',
          resizable: true,
          key: 'totalMileage',
          ellipsis: 'true',
          width: 110,
          render: function (h, params) {
            if (params.row.totalMileage !== 0) {
              return h('div', params.row.totalMileage / 10)
            } else {
              return h('div', params.row.totalMileage)
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetimeLongValue',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetimeLongValue) {
              let d = new Date(params.row.createDatetimeLongValue)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          sortable: 'custom',
          key: 'remark',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'TripServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onFilterClick () {
      if (this.dateFilter.length==0) {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      let startDate = this.dateFilter[0]
      let endDate = this.dateFilter[1]
      this.startDate = new Date(startDate).Format('yyyy-MM-dd 00:00:00')
      this.endDate = new Date(endDate).Format('yyyy-MM-dd 23:59:59')
      this.setPage(1)
    },
    filterChange () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    setPage (page) {
      this.pageIndex = page
      this.listLoadding = true

      let sortParam = null
      let queryParams = []

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }
      if (this.terminalNum) {
        queryParams.push(genQueryParam('terminalNum', 'EQSTR', this.terminalNum))
      }
      if (this.startDate && this.endDate) {
        queryParams.push(genQueryParam('startDatetimeLongValue', 'BTDT', this.startDate, this.endDate))
      }
      if (this.tripTypeFilter) {
        queryParams.push(this.tripTypeFilter)
      }

      store.dispatch('TripServ_GetPage', {
        params: null,
        urlparams: {
          ps: this.pageFilter,
          p: page,
          q: queryParams,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_Trip_GetPageResult) {
        return store.getters.get_Trip_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_Trip_GetPageResult) {
        return store.getters.get_Trip_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_Trip_GetPageResult) {
        return store.getters.get_Trip_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
